import EmailNotificationFormContainer from "./EmailNotificationFormContainer";
import EmailNotificationForm from "./EmailNotificationForm";
import EmailNotificationSummary from "./EmailNotificationSummary";
import HttpNotificationForm from "./HttpNotificationForm";
import HttpNotificationSummary from "./HttpNotificationSummary";
import LegacyNotificationForm from "./LegacyNotificationForm";
import LegacyNotificationFormContainer from "./LegacyNotificationFormContainer";
import LegacyNotificationSummaryContainer from "./LegacyNotificationSummaryContainer";
import HttpNotificationSummaryV2 from "./HttpNotificationSummaryV2";
import HttpNotificationFormV2 from "./HttpNotificationFormV2";
import EmailNotificationDetails from "../event-notification-details/EmailNotificationDetails";
import HttpNotificationDetails from "../event-notification-details/HttpNotificationDetails";
import LegacyNotificationDetails from "../event-notification-details/LegacyNotificationDetails";
import HttpNotificationDetailsV2 from "../event-notification-details/HttpNotificationDetailsV2";
const pluginExports = {
  eventNotificationTypes: [
    {
      type: "email-notification-v1",
      displayName: "Email Notification",
      displayNameKey: "event_notifications:types.email",
      formComponent: EmailNotificationFormContainer,
      summaryComponent: EmailNotificationSummary,
      detailsComponent: EmailNotificationDetails,
      defaultConfig: EmailNotificationForm.defaultConfig
    },
    {
      type: "http-notification-v1",
      displayName: "HTTP Notification",
      displayNameKey: "event_notifications:types.http",
      formComponent: HttpNotificationForm,
      summaryComponent: HttpNotificationSummary,
      detailsComponent: HttpNotificationDetails,
      defaultConfig: HttpNotificationForm.defaultConfig
    },
    {
      type: "http-notification-v2",
      displayName: "Custom HTTP Notification",
      displayNameKey: "event_notifications:types.http_v2",
      formComponent: HttpNotificationFormV2,
      summaryComponent: HttpNotificationSummaryV2,
      detailsComponent: HttpNotificationDetailsV2,
      defaultConfig: HttpNotificationFormV2.defaultConfig
    },
    {
      type: "legacy-alarm-callback-notification-v1",
      displayName: "Legacy Alarm Callbacks",
      displayNameKey: "event_notifications:types.legacy",
      formComponent: LegacyNotificationFormContainer,
      summaryComponent: LegacyNotificationSummaryContainer,
      detailsComponent: LegacyNotificationDetails,
      defaultConfig: LegacyNotificationForm.defaultConfig
    }
  ]
};
export default pluginExports;
